import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  OnDestroy,
} from "@angular/core";
import { Table, TableModule } from "primeng/table";
import * as FileSaver from "file-saver";
import { ActivatedRoute } from "@angular/router";
import { InvoiceReviewSummaryService } from "../../../core/services/invoice-review-summary.service";
import { IpClientDepositDetailValue } from "../../../core/models/invoice-review/IpClientDepositDetailValue";
import { LoaderService } from "../../../core/services/loader.service";
import { SpinnerComponent } from "../../../shared/components/spinner/spinner.component";
import { CommonModule } from "@angular/common";

@Component({
  selector: "jni-invoice-review-client-deposit",
  templateUrl: "./client-deposit.component.html",
  styleUrls: ["./client-deposit.component.scss"],
  imports: [SpinnerComponent, CommonModule, TableModule],
})
export class InvoiceReviewClientDepositComponent implements OnInit, OnDestroy {
  @Input() invoiceReviewNumber = "";
  @Output() scrollHiddenStatus = new EventEmitter();

  ipClientDepositDetailValue: IpClientDepositDetailValue[] = [];

  @ViewChild("dt") table!: Table;

  constructor(
    private _loaderService: LoaderService,
    public _activatedRoute: ActivatedRoute,
    private _invoiceReviewSummaryService: InvoiceReviewSummaryService
  ) {}

  ngOnInit(): void {
    this.getFreightCharges();
  }

  clearTable(table: Table) {
    table.clear();
  }

  exportExcelFile() {
    this.exportExcelForFilterData(this.ipClientDepositDetailValue);
  }

  exportExcelForFilterData(filterclientlist: IpClientDepositDetailValue[]) {
    const object = filterclientlist.map(datum => {
      return {
        ["Creation Date"]: datum.InvoiceDate,
        ["Amount"]: datum.Amount,
        ["Description"]: datum.Txt,
      };
    });

    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(object);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: ArrayBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      this.saveAsExcelFile(excelBuffer, "FreightChargeReport");
    });
  }

  saveAsExcelFile(buffer: ArrayBuffer, fileName: string): void {
    const EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const EXCEL_EXTENSION = ".xlsx";
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(
      data,
      fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
    );
  }

  ngOnDestroy(): void {
    this.scrollHiddenStatus.emit();
  }

  getFreightCharges() {
    this._loaderService.setLoaderState(true);
    if (this.invoiceReviewNumber) {
      const oDataFilter = `?$filter=ProposalId eq '${this.invoiceReviewNumber}'`;
      this._invoiceReviewSummaryService
        .getIpClientDeposit(oDataFilter)
        .subscribe({
          next: res => {
            this.ipClientDepositDetailValue = res.data;
            this._loaderService.setLoaderState(false);
          },
          error: () => {
            this._loaderService.setLoaderState(false);
          },
        });
    }
  }
}
